import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import PricingPerSquareMeter from './components/PricingPerSquareMeter';
import FixedPricing from './components/FixedPricing';
import EmptyApartments from './components/EmptyApartments';
import FurnishedApartments from './components/FurnishedApartments';
import IncludedServices from './components/IncludedServices';
import HowItWorks from './components/HowItWorks';
import Regions from './components/Regions';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Impressum from './components/Impressum';
import './App.css';

const HomePage = () => (
  <>
    <Hero />
    <div id="vorteile">
      <Benefits />
    </div>
    <div id="preise">
      <PricingPerSquareMeter />
      <FixedPricing />
    </div>
    <EmptyApartments />
    <FurnishedApartments />
    <div id="leistungen">
      <IncludedServices />
    </div>
    <div id="ablauf">
      <HowItWorks />
    </div>
    <div id="regionen">
      <Regions />
    </div>
    <div id="faq">
      <FAQ />
    </div>
    <div id="kontakt">
      <Contact />
    </div>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-black">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </BrowserRouter>
  );
}

export default App;